import { SPage } from "servisofts-component";
import Model from "../../../Model";
import title from "./title";




//const model = Model.popup_inicio;
export const Parent = {
    name: "title_tutoriales",
    path: `/marketing/title_tutoriales`,
    //model
}
export default SPage.combinePages(Parent.name, {

    "": title,
})
